import { useEffect } from "react";
import { Radio, Printer, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ProcessFlow } from "@/components/ProcessFlow";

const ACCESS = [
  { cap: "Submit & track own requests", m: true, c: false, l: false },
  { cap: "View all requests", m: false, c: true, l: true },
  { cap: "Approve / deny requests", m: false, c: false, l: true },
  { cap: "Produce, assign & publish", m: false, c: true, l: false },
  { cap: "Approve the proof (their own)", m: true, c: false, l: false },
];

export default function ProcessPoster() {
  useEffect(() => {
    localStorage.setItem("cc_skin", "aka");
    document.documentElement.setAttribute("data-skin", "aka");
  }, []);

  return (
    <div className="min-h-screen bg-background print:bg-white" data-testid="process-poster">
      <style>{`@media print { @page { size: landscape; margin: 12mm; } .no-print { display: none !important; } body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }`}</style>

      <div className="mx-auto max-w-6xl px-6 py-8">
        <div className="mb-6 flex items-start justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Radio className="h-6 w-6" />
            </div>
            <div>
              <p className="font-heading text-2xl font-bold leading-none tracking-tight">CommConnect</p>
              <p className="mt-1 text-sm text-muted-foreground">Communications Request — Process Flow</p>
            </div>
          </div>
          <Button onClick={() => window.print()} className="no-print rounded-full" data-testid="poster-print-btn">
            <Printer className="mr-1.5 h-4 w-4" /> Print / Save as PDF
          </Button>
        </div>

        <p className="no-print mb-6 rounded-lg border border-dashed border-border bg-secondary/40 p-3 text-sm text-muted-foreground">
          Tip: use your browser's print dialog and choose <b>Save as PDF</b> (landscape) to create a one-page reference chapters can post.
        </p>

        <ProcessFlow />

        <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2">
          <div>
            <div className="mb-2 flex items-center gap-2">
              <ShieldCheck className="h-4 w-4 text-accent" />
              <h3 className="font-heading text-sm font-semibold">Who can do what</h3>
            </div>
            <table className="w-full text-xs">
              <thead>
                <tr className="border-b border-border text-left uppercase tracking-wide text-muted-foreground">
                  <th className="py-2 pr-2">Capability</th>
                  <th className="px-2 py-2 text-center">Member</th>
                  <th className="px-2 py-2 text-center">Comms</th>
                  <th className="px-2 py-2 text-center">Leadership</th>
                </tr>
              </thead>
              <tbody>
                {ACCESS.map((r, i) => (
                  <tr key={i} className="border-b border-border/60 last:border-0">
                    <td className="py-1.5 pr-2">{r.cap}</td>
                    {[r.m, r.c, r.l].map((v, j) => (
                      <td key={j} className="px-2 py-1.5 text-center">
                        {v ? <span className="text-primary">✓</span> : <span className="text-muted-foreground/40">—</span>}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex flex-col justify-end">
            <p className="text-xs text-muted-foreground">
              Everyone is notified by email at each step. If the requestor asks for changes at the proof stage,
              the request returns to Production and continues from there.
            </p>
            <p className="mt-3 text-[11px] font-medium text-foreground/60">
              Alpha Epsilon Gamma Omega · CommConnect · mycommconnect.com/AEGO
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
